export const localStorageLoginSync = {
  key: 'snci'
};

export const localStorageLogoutSync = {
  key: 'snco',
  value: 'true'
};
